import axios from 'axios'

const LaterPostingService = {
  async get (params = {}) {
    return axios.get('po/inter-warehouse-transfer/later-postings', { params })
  },

  async show (id) {
    return axios.get(`po/inter-warehouse-transfer/later-postings/${id}`)
  },

  async post (params = {}) {
    return axios.post('po/inter-warehouse-transfer/later-postings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`po/inter-warehouse-transfer/later-postings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`po/inter-warehouse-transfer/later-postings/${data.id}`, { data })
  }
}

export default LaterPostingService
